import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/about/about.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/about/TableOfContents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/tech/TechInfo.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Accordion.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Arrow.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Avatar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/AvatarGroup.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Background.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Badge.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Button.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Card.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Carousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Checkbox.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Chip.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/ColorInput.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Column.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/CompareImage.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/DateInput.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/DatePicker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/DateRangeInput.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/DateRangePicker.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Dialog.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Dropdown.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/DropdownWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Fade.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Feedback.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Flex.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/GlitchFx.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Grid.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Heading.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/HeadingLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/HeadingNav.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/HoloFx.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Icon.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/IconButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/InlineCode.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Input.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/InteractiveDetails.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Kbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Kbd.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/LetterFx.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Line.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Logo.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/LogoCloud.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/MegaMenu.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/NumberInput.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/OTPInput.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/PasswordInput.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/RadioButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/RevealFx.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Row.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Scroller.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/SegmentedControl.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Select.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Skeleton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/SmartImage.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/SmartLink.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/StatusIndicator.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/StyleOverlay.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/StylePanel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Switch.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Table.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Tag.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/TagInput.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Text.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Textarea.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/ThemeSwitcher.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/TiltFx.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Toast.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Toaster.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/ToastProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/ToggleButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/Tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/User.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/once-ui/components/UserMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CodeBlock"] */ "/vercel/path0/src/once-ui/modules/code/CodeBlock.tsx");
